import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import MqttService from "../services/mqtt.service";
import { LabelImportantSharp } from "@mui/icons-material";


const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};


export const getMessages = createAsyncThunk(
  "mqtt/get_messages",
  async ({search}, thunkAPI) => {
    try {

      const data = await MqttService.getMessages(search);
      return { messages: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getMessage = createAsyncThunk(
  "mqtt/get_message",
  async ({message}, thunkAPI) => {
    try {
      const data = await MqttService.getMessage(message);
      return { message: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCommands = createAsyncThunk(
  "mqtt/get_commands",
  async ({search}, thunkAPI) => {
    try {

      const data = await MqttService.getCommands(search);
      return { commands: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCommand = createAsyncThunk(
  "mqtt/get_command",
  async ({username}, thunkAPI) => {
    try {
      const data = await MqttService.getCommand(username);
      return { command: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


const initialState = { data: list, loading: false, messages: list, messagesLoading: false};

const mqttSlice = createSlice({
  name: "commands",
  initialState,
  extraReducers: {

    [getMessages.pending]: (state, action) => {
      state.messagesLoading = true;
    },
    [getMessages.fulfilled]: (state, action) => {
      state.messages = action.payload.messages; 
      state.messagesLoading = false;
    },
    [getMessages.rejected]: (state, action) => {
      state.messages = list
      state.messagesLoading = false;
    },


    [getMessage.pending]: (state, action) => {
      state.messagesLoading = true;
    },
    [getMessage.fulfilled]: (state, action) => {

      state.messages.list.push(action.payload.message)
      state.messages.total ++;

      state.messagesLoading = false;
    },
    [getMessage.rejected]: (state, action) => {
      state.messagesLoading = false;
    },

    [getCommands.pending]: (state, action) => {
      state.loading = true;
    },
    [getCommands.fulfilled]: (state, action) => {
      state.data = action.payload.commands; 
      state.loading = false;
    },
    [getCommands.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },


    [getCommand.pending]: (state, action) => {
      state.loading = true;
    },
    [getCommand.fulfilled]: (state, action) => {

      state.data.list.push(action.payload.command)
      state.data.total ++;

      state.loading = false;
    },
    [getCommand.rejected]: (state, action) => {
      state.loading = false;
    },


  },
});


const { reducer } = mqttSlice;
export default reducer;